import {
    VideoPlayButtonInnerCircleStyled,
    VideoPlayButtonStyled,
} from './styled/VideoPlayButtonStyled';
import { BinIcon } from '../../../../components/icon/Icon';
import { memo } from 'react';
import classNames from 'classnames';

export const VideoPlayButton = memo(({hover, ...otherProps}) => (
    <VideoPlayButtonStyled {...otherProps}>
        <VideoPlayButtonInnerCircleStyled className={classNames({ 'hover': hover })}>
            <BinIcon name="IcPlay" style={{ fontSize: '24px' }} />
        </VideoPlayButtonInnerCircleStyled>
    </VideoPlayButtonStyled>
));